import { FunctionComponent } from 'react'
import { rucksack, Box } from '@black-bear-energy/rucksack'
import {
  AddBoxRounded,
  CheckCircleRounded,
  FilePresentRounded,
  NotificationImportantRounded,
} from '@mui/icons-material'
import { CircledIcon } from './CircledIcon'
import { Field } from './Field'

export const DocumentCountField: FunctionComponent<DocumentCountFieldProps> = ({
  variant,
  value,
  isPending,
}) => {
  const documentCountFieldVariant = {
    required: {
      icon: <FilePresentRounded />,
      color: rucksack.palette.error.light,
      label: 'Required Uploads',
    },
    pendingReview: {
      icon: <NotificationImportantRounded />,
      color: rucksack.palette.warning.light,
      label: 'Pending Reviews',
    },
    verified: {
      icon: <CheckCircleRounded />,
      color: rucksack.palette.success.light,
      label: 'Verified',
    },
    additional: {
      icon: <AddBoxRounded />,
      color: rucksack.palette.info.light,
      label: 'Additional Uploads',
    },
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2.5,
      }}
    >
      <CircledIcon
        icon={documentCountFieldVariant[variant].icon}
        color={documentCountFieldVariant[variant].color}
      />
      <Field
        label={documentCountFieldVariant[variant].label}
        isPending={isPending}
      >
        {value}
      </Field>
    </Box>
  )
}

interface DocumentCountFieldProps {
  variant: 'required' | 'pendingReview' | 'verified' | 'additional'
  value: string
  isPending?: boolean
}
